import { EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { IpService, ServiceIpInfoResponse } from 'src/app/services/api/ip/ip.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { ProductService } from 'src/app/services/api/product/product.service';


@Component({
  selector: 'app-order-details-general',
  templateUrl: './order-details-general.component.html',
  styleUrls: ['./order-details-general.component.scss']
})
export class OrderDetailsGeneralComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();
  @Output() decompositeOrderEvent = new EventEmitter();

  constructor(
    private ipService: IpService,
    private notificationsService: NotificationsService,
    private ordersService: OrdersService,
    private productService: ProductService,
    private translateService: TranslateService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
  }

  cancelOrder() {
    this.cancelOrderEvent.emit();
  }

  decompositeOrder() {
    this.decompositeOrderEvent.emit();
  }
}
